export type TapOutboxBatch = {
  rootCommandId: string;
  commandId: string;
  clientSessionId: string;
  firstSeq: string;
  lastSeq: string;
  requestedCount: number;
  originalRequestedCount: number;
  acceptedCount: number;
  energySpent: number;
  optimisticRewardPerTap: string;
  rateRetryAttempt: number;
  deliveryAttempts: number;
  sequenceRecoveryAttempts?: number;
  nextAttemptAt: number;
  createdAt: number;
};

export type TapOutboxState = {
  version: 1;
  ownerKey: string;
  seasonId: string;
  clientSessionId: string;
  lastAssignedSeq: string;
  batches: TapOutboxBatch[];
};

export type TapOutboxRepository = {
  load(scope: string): Promise<TapOutboxState | null>;
  save(scope: string, state: TapOutboxState): Promise<void>;
  clear(scope: string): Promise<void>;
};

export type PendingTapSummary = {
  count: number;
  reward: string;
  delayed: boolean;
};

export function emptyPendingTapSummary(): PendingTapSummary {
  return { count: 0, reward: "0", delayed: false };
}

export function pendingTapSummary(state: TapOutboxState | null, now?: number): PendingTapSummary {
  if (state === null) return emptyPendingTapSummary();
  let count = 0;
  let reward = 0n;
  let delayed = false;
  for (const batch of state.batches) {
    count += batch.requestedCount;
    reward += BigInt(batch.optimisticRewardPerTap) * BigInt(batch.requestedCount);
    delayed ||= batch.deliveryAttempts > 0 || (now !== undefined && now - batch.createdAt >= 10_000);
  }
  return { count, reward: reward.toString(), delayed };
}
